export const LANGUAGES = [
  { code: 'en', nativeName: 'English', intlLocale: 'en-IN' },
  { code: 'ta', nativeName: 'தமிழ்', intlLocale: 'ta-IN' },
  { code: 'hi', nativeName: 'हिन्दी', intlLocale: 'hi-IN' },
  { code: 'te', nativeName: 'తెలుగు', intlLocale: 'te-IN' },
] as const;

export type Language = (typeof LANGUAGES)[number]['code'];

export const DEFAULT_LANGUAGE: Language = 'en';

export function isLanguage(value: unknown): value is Language {
  return LANGUAGES.some(language => language.code === value);
}

export function intlLocaleFor(language: Language): string {
  return LANGUAGES.find(item => item.code === language)?.intlLocale ?? 'en-IN';
}
